import { getBackendOrigin } from './backendUrl';

const BACKEND_HOST = getBackendOrigin();

/**
 * Format image path to full URL if stored locally on backend (/uploads/...)
 */
export function getImageUrl(path) {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:') || path.startsWith('blob:')) {
    return path;
  }
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${BACKEND_HOST}${cleanPath}`;
}
